export default function SendMailTimeChange(props) {
  const { classNameProps } = props;
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNameProps}>
      <path d="M14 8C11.24 8 9 10.24 9 13C9 15.76 11.24 18 14 18C16.76 18 19 15.76 19 13C19 10.24 16.76 8 14 8ZM15.65 15.35L13.5 13.2V10H14.5V12.79L16.35 14.64L15.65 15.35Z" />
      <path d="M8 8L2 6.5V3.01L10.87 6.75C11.81 6.28 12.87 6 14 6C14.1 6 14.19 6.01 14.28 6.01L0 0V16L7 13.05C7 13.03 7 13.02 7 13C7 12.2 7.14 11.44 7.39 10.72L2 12.99V9.5L8 8Z" />
    </svg>
  );
}
